import React, { useCallback, useContext, useMemo, useState, useEffect } from 'react';
import XRayGeneratorHistoryContext from 'app/providers/XRayGeneratorHistoryProvider/context';
import { Button, Dropdown } from 'semantic-ui-react';
import { useSelector } from 'react-redux';
import { selectXRayOperators } from 'app/redux/xrayGeneratorConfiguration/reducer';
import { FormattedMessage, useIntl } from 'react-intl';
import electron from 'app/native/node/electron';
import saveFileWithoutOverwrite from 'app/utils/saveFileWithoutOverwrite';
import OperatorDeleteButton from '../OperatorDeleteButton';
import './style.scss';

const XRayGeneratorHistoryExtractor = () => {
  const xRayGeneratorHistory = useContext(XRayGeneratorHistoryContext);
  if (!xRayGeneratorHistory) return null;

  const operators = useSelector(selectXRayOperators);
  const [operatorToExtract, setOperatorToExtract] = useState();
  const intl = useIntl();

  const operatorsOptions = useMemo(
    () =>
      operators?.map((operator) => ({
        key: operator,
        value: operator,
        text: operator,
        content: <OperatorDeleteButton operator={operator} />,
      })),
    [operators]
  );

  const extractOperator = useCallback(async () => {
    const csvData = await xRayGeneratorHistory.getHistoryAsCsv(operatorToExtract);
    const directory = electron().remote.app.getPath('downloads');
    const filename = 'xray_history.csv';
    const xrayHistorySavePath = await saveFileWithoutOverwrite(directory, filename, csvData);

    electron().shell.openPath(xrayHistorySavePath);
  }, [operatorToExtract, xRayGeneratorHistory]);

  return (
    <div style={{ display: 'flex', gap: '5px' }}>
      <Dropdown
        options={operatorsOptions || []}
        value={operatorToExtract}
        clearable
        selection
        search
        // Not test, but an important props
        selectOnBlur={false}
        onChange={(event, { value }) => setOperatorToExtract(value)}
        placeholder={intl.formatMessage({ id: 'xray_generator.operator.extract_all' })}
        data-testid="dropdownOptions"
        className="xrayOperatorSelect"
      />
      <Button onClick={extractOperator}>
        <FormattedMessage id="xray_generator.operator.extract" />
      </Button>
    </div>
  );
};

export default React.memo(XRayGeneratorHistoryExtractor);
